export default __webpack_public_path__ + "static/media/ingenga.ddb86b71.jpg";